import { createGlobalStyle } from "styled-components";
import backgroudImage from "../../assets/imgs/background.png";

export const Reset = createGlobalStyle`
     * {
        margin:0;
        padding: 0;
        box-sizing: border-box;
    }
    body, html{
        width: 100vw;
        height: 100vh;
    }
    body {
        font-family: var(--font-family);
        font-size: var(--fz-body);
        background-color: var(--color-gray-1);
        background-image: url(${backgroudImage});
	    background-repeat: repeat;
        color: var(--color-brand-2);
        -webkit-font-smoothing: antialiased;
        overflow-x: hidden;
    
    }
    
    
    h1, h2, h3, h4, h5, h6, strong {
        font-weight: 500;
    }

    button{
        cursor: pointer;

        font-family: var(--font-family);

        border: none;
        background: transparent;
    }

    input{
        font-family: var(--font-family);
    }

    a, abbr{
        color: unset;
        text-decoration: none;

    }
    ul, ol, li{
        list-style: none;
    }   text-decoration: none;
    
`;
